import { IApplicationState } from '../../types/redux';

/* istanbul ignore next */
export function selectGeoSubdomains(state: IApplicationState): string[] {
  return state.geoSubdomains;
}
